import { Component } from 'preact';

export default class Options extends Component {
  state = {
    disabled: false
  }

  componentWillMount () {
    if (this.props.disabled) {
      this.setState({ disabled: true });
    }
  }

  componentWillReceiveProps (props) {
    if (props.disabled !== this.state.disabled) {
      this.setState({ disabled: props.disabled });
    }
  }

  // componentDidMount () {
  //   if (this.props.disabled) {
  //     this.legend.focus();
  //   }
  // }

  onInput = (event) => {
    if (this.props.onInput) {
      const { name, checked } = event.target;

      // console.log(name, checked);

      this.props.onInput({ name, checked });
    }
  }

  onSelect = () => {
    this.setState({ disabled: true });

    if (this.props.onSelect) {
      this.props.onSelect(this.props.name);
    }
  }

  onKeyDown = event => {
    let key = event.key;

    if (!key) {
      const keyCode = event.which || event.keyCode;

      switch (keyCode) {
        case 13:
        key = 'Enter';
        break;

        case 32:
        key = ' ';
        break;
      }
    }
    
    if (key === 'Enter' || key === ' ') {
      this.onSelect();

      if (document.activeElement) {
        // document.activeElement.blur();

        this.firstCheckbox.focus();

        // const legends = document.querySelectorAll('.Options legend');

        // for (let i = 0; i < legends.length; i++) {
        //   if (legends[i] !== this.legend) {
        //     legends[i].parentNode.querySelector('li input').focus();
        //     break;
        //   }
        // }
      }
    }
  }

  render (props, state) {
    const { title, items, tabIndex = false } = props;
    const { disabled } = state;

    return <fieldset class={`Options${disabled ? ' disabled' : ''}`} onClick={ disabled && this.onSelect }>
      <legend tabIndex={ disabled ? 0 : -1 } onKeyDown={ disabled && this.onKeyDown } ref={legend => this.legend = legend}>
        { title }
      </legend>
      {/*
       <legend><label htmlFor="options-enable">{ title }</label></legend>
      { disabled && <input type="checkbox" id="options-enable" defaultChecked={ false } onInput={ this.onSelect } /> }
      */}

      <ul>
        {
          items.map((item, i) => {
            let label;

            if (item.labelShort && window.innerWidth <= 450) {
              label = item.labelShort;
            }

            else {
              label = item.label ||
              `${item.key[0].toUpperCase()}${item.key.slice(1)}`;
            } 

            return <li>
              <input type="checkbox" id={ `checkbox-${item.key}` } name={ item.key } defaultChecked={ item.checked !== false } onChange={ this.onInput } tabIndex={ disabled ? -1 : tabIndex } ref={checkbox => {
                  if (i === 0) {
                    this.firstCheckbox = checkbox;
                  }
                }} />
              <label htmlFor={ `checkbox-${item.key}` }>
                <span class="icon">{ item.char }</span> <span class="title">{ label }</span></label>
            </li>
          })
        }
      </ul>
    </fieldset>;
  }
}



// WEBPACK FOOTER //
// ./components/Options.js